// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-m_eU","advertDetailHeaderPrice__value":"c-m_eV","advertDetailHeaderPrice__label":"c-m_eW"};